export function initMenuToggle() {
    const menuButton = document.querySelector('.menu-toggle');
    const menu = document.getElementById('main-menu');
    const overlay = document.getElementById('main-overlay');
    const body = document.body;
    let menuOpen = false;
    
    function toggleMenu() {
      if (!menu) return;
      
      menuOpen = !menuOpen;
      
      if (menuOpen) {
        // Remove hidden immediately when opening
        menu.classList.add('active');
        menu.classList.remove('pointer-events-none');
        menu.classList.add('opacity-100');
        menu.classList.remove('translate-x-full');
        menu.classList.add('translate-x-0');
        overlay.classList.remove('pointer-events-none');
        overlay.classList.add('opacity-100');
        body.classList.add('overflow-hidden');
        menuButton?.setAttribute('aria-expanded', 'true');
      } else {
        menu.classList.remove('active');
        menu.classList.add('pointer-events-none');
        menu.classList.remove('opacity-100');
        menu.classList.add('translate-x-full');
        menu.classList.remove('translate-x-0');
        overlay.classList.add('pointer-events-none');
        overlay.classList.remove('opacity-100');
        body.classList.remove('overflow-hidden');
        menuButton?.setAttribute('aria-expanded', 'false');
      }
    }
    
    // Add click event to menu button
    if (menuButton) {
      menuButton.addEventListener('click', toggleMenu);
      menuButton.setAttribute('aria-controls', 'main-menu');
      menuButton.setAttribute('aria-expanded', 'false');
    }
    
    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuOpen) {
        toggleMenu();
      }
    });
    
    // Close menu when clicking close button
    const closeButton = document.querySelector('#main-menu .close-button');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        if (menuOpen) toggleMenu();
      });
    }
    
    // Close menu when clicking outside of it
    document.addEventListener('click', (e) => {
      if (menuOpen && menu && !menu.contains(e.target) && !menuButton.contains(e.target)) {
        toggleMenu();
      }
    });
    
    return {
      toggleMenu,
      isOpen: () => menuOpen
    };
  } 